import React, { createContext, useContext, useState } from 'react';

const HorseModalContext = createContext();

export const useHorseModal = () => {
  const context = useContext(HorseModalContext);
  if (!context) {
    throw new Error('useHorseModal must be used within HorseModalProvider');
  }
  return context;
};

export const HorseModalProvider = ({ children }) => {
  // Modal stack to support nested modals
  // Limit to 5 modals to prevent performance issues and UX problems
  const MAX_MODAL_DEPTH = 5;
  const [modalStack, setModalStack] = useState([]);

  const openHorseModal = (horseToEdit = null, onSuccess = null) => {
    setModalStack((prev) => {
      if (prev.length >= MAX_MODAL_DEPTH) {
        console.warn(`Maximum modal depth (${MAX_MODAL_DEPTH}) reached. Cannot open another modal.`);
        return prev;
      }
      return [
        ...prev,
        {
          id: Date.now(), // Unique ID for this modal instance
          horse: horseToEdit,
          onSuccessCallback: onSuccess,
        },
      ];
    });
  };

  const closeHorseModal = () => {
    setModalStack((prev) => prev.slice(0, -1)); // Remove only the topmost modal
  };

  const closeAllModals = () => {
    setModalStack([]);
  };

  // Get the topmost modal (most recent)
  const topModal = modalStack.length > 0 ? modalStack[modalStack.length - 1] : null;

  const value = {
    modalStack,
    isOpen: modalStack.length > 0,
    horse: topModal?.horse || null,
    onSuccessCallback: topModal?.onSuccessCallback || null,
    openHorseModal,
    closeHorseModal,
    closeAllModals,
  };

  return (
    <HorseModalContext.Provider value={value}>
      {children}
    </HorseModalContext.Provider>
  );
};

